/*
Sohel 11/02/2022 2699823790 Added Attached Trigger Form
Sohel 11/02/2022 2699823790 Added client code validation
Sohel 11/02/2022 2699823790 fixed toast issue
Sohel 11/03/2022 2699823790 pass event Type
Sohel 11/04/2022 2699823790 remove extra code
Prakash 11/22/2022 2699823790 Added conditional card spacing.
Rajesh 12/15/2022 2699823790 added role access
sai krisha 30/12/2022 2699761741 add code description values
manikanta 01/04/2022 2699761741 batch triggers save and close functionality
manikanta 01/05/2022 2699761741 batch triggers go back button functionality
manikanta 01/05/2022 2699761741 event  triggers go back alignment
AKhila 01/23/2023 2699761741 removed double dialog box
Ravi 02/21/2023 2699761741 removed Continue After Processing from Mandatory field
Raghu 02/22/2023 2699761741 added new class for input field and buttons
Raghu 02/27/2023 2699761741 fixed alignments
Prakash 03/28/2023 2699761741 fixed input filed issue.
Akhila 04/04/2023 2699761741 Added corporate name and site name field and rename fieldss
Guru Prasad 04/04/2023 2699761741 Fixed column alignments based on input field values
Akhila 04/04/2023 2699761741 Added prepopulation and updated data
Akhila 04/04/2023 2699761741 Added alert existing code and arrange the fields
Akhila 04/05/2023 2699761741 bug fixed client code dropDownData
Sohel 04/05/2023 2699823790 Fixed Validation Issue
Sohel 04/07/2023 2699823790 Client Code and Site Name Prepopulate issue
Prakash 13/04/2023 2699823790 remove margin top
Akhila 04/17/2023 2699823790 Added Corporate Value Based on Company
Sohel 04/18/2023 2699823790 Fixed Prepopulate Issue
Prakash 04/26/2023 2699823790 fixed button speacing  issue
Akhila 05/03/2023 2699823790 bug fixed prepopulation on status, company field and table column copmany data
Sohel 05/23/2023 3075154998 Fixed Validation Toast Issue
Sohel 05/23/2023 3075154998 Changed Validation Message
Sohel 05/24/2023 3075154998 Fixed client code validation issue
Akhila 05/31/2023 3075154998 unsaved changes bug fixed
Ravi 06/14/2023 3075154998 rename Revone to RevOne
Sohel 12/05/2023 3075154998 Trigger field removed grey color  
*/
import React, {useContext, useEffect, useRef, useState} from 'react';
import GuiAutoComplete from '../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../components/FormComponents/GuiTextField';
import {Formik} from 'formik';
import {
  Button,
  FormHelperText,
  Grid,
  TextField,
  InputAdornment,
  Tooltip,
} from '@material-ui/core';
import ErrorBoundaryForComponents from '../../../../util/ErrorBoundaryForComponents';
import * as Yup from 'yup';
import {ThemeContext} from '../../../../themes/ThemeProvider';
import {useSelector} from 'react-redux';
import SearchEventTactics from '../../Triggers/AddTrigger/AddClient/SearchEventTactics';
import {Search, Clear, ArrowBack} from '@material-ui/icons';
import {
  fetchClientNumberData,
  fetchSiteNameData,
  resetClientNumber,
  resetSiteName,
  fetchCorporateNameData,
  resetCorporateName,
} from '../../../../redux/reducers/TriggerGroup';
import {useDispatch} from 'react-redux';
import BreadCrums from '../../../../util/BreadCrum';
import {fetchCompanyDropDownData} from '../../../../redux/reducers/clientMangement/Organizaation';

import {Alert} from '@material-ui/lab';
import PageLoader from '../../../../components/PageLoader';

const correspondingClientsTypes = [
  {key: 'Y', value: 'Yes'},
  {key: 'N', value: 'No'},
];
const groupTypeDropdownValues = [
  {key: 'Corporate', value: 'Corporate'},
  {key: 'Site', value: 'Site'},
  {key: 'Department', value: 'Department'},
  {key: 'RevOne Company', value: 'RevOne Company'},
];
const AddClientForm = ({
  isEdit,
  setIsEdit,
  AttachedTriggersData,
  setAttachedTriggersData,
  setOpenPopup,
  clientRowData,
  unique,
  setUnique,
  eventType,
  eventCode,
  eventDescription,
  handleDirty,
}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const {
    siteNameData,
    clientNumberData,
    corporateNameData,
    isLoading,
  } = useSelector(({addTriggerGroup}) => addTriggerGroup);

  const {companyAPIdata} = useSelector(({organization}) => organization);
  const [searchEventTactics, setSearchEventTactics] = useState(false);
  const [cardSpace, setCardSpace] = useState(false);
  const [selectedEventTrigger, setSelectedEventTrigger] = useState([]);
  const getObjects = (option, options) => {
    const option1 = Number(option);
    let label = {};
    options &&
      options.length > 0 &&
      options.forEach((item) => {
        if (
          item?.clientNumber === option ||
          item.key === option ||
          item?.corporateName === option ||
          item?.siteName === option ||
          item?.companyId === option1
        ) {
          label = item;
        }
      });
    return label;
  };
  const initialVal = {
    clientCode:
      isEdit && clientRowData && clientRowData.clientCode ?
        getObjects(clientRowData?.clientCode, clientNumberData) :
        '',
    correspondingClients:
      isEdit && clientRowData && clientRowData?.correspondingClients ?
        getObjects(clientRowData?.correspondingClients, correspondingClientsTypes) :
        '',

    eventTactic: isEdit && clientRowData ? clientRowData?.eventTactic?.join(', ') : '',
    type:
      isEdit && clientRowData && clientRowData?.type ?
        getObjects(clientRowData?.type, groupTypeDropdownValues) :
        null,
    phase:
      isEdit && clientRowData && clientRowData?.phase ? // ? getObject(clientRowData?.phase?.toString(), PHASE, dropDownData)
      // : null,
        getObjects(clientRowData?.phase, companyAPIdata) :
        null,
    corporateName:
      isEdit && clientRowData && clientRowData?.corporateName ? //   ? getObjects(clientRowData?.corporateName, corporateAPIdata)
        getObjects(clientRowData?.corporateName, corporateNameData) :
        '',
    siteName:
      isEdit && clientRowData && clientRowData?.siteName ?
        getObjects(clientRowData?.siteName, siteNameData) :
        '',
  };
  const [initialValues, setInitialValues] = useState(initialVal);

  const {roleData} = useSelector(({role}) => role);
  const disable = roleData?.window?.['Event Triggers']?.['ET'];
  const handleEventTacticSearch = () => {
    setSearchEventTactics(false);
  };
  const formRef = useRef();
  useEffect(() => {
    handleDirty(false, 'reset');
  }, []);
  useEffect(() => {
    setSelectedEventTrigger(isEdit && clientRowData ? clientRowData?.eventTactic : []);
  }, [isEdit]);

  const schema = Yup.object().shape({
    clientCode: Yup.mixed().test('clientCode', 'Department is required', (value, ctx) => {
      if (!value?.clientNumber && ctx.parent?.type?.value === 'Department') {
        return false;
      } else {
        return true;
      }
    }),
    type: Yup.mixed().test('type', 'Type is required', (value) => {
      if (!value?.value) {
        return false;
      } else {
        return true;
      }
    }),
    // correspondingClients: Yup.mixed().test(
    //   "correspondingClients",
    //   "Continue After Processing is required",
    //   (value) => {
    //     if (!value) {
    //       return false;
    //     } else {
    //       return true;
    //     }
    //   }
    // ),
    eventTactic: Yup.mixed().test('Triggers', 'Triggers is required', (value) => {
      if (selectedEventTrigger?.length > 0) {
        return true;
      } else {
        return false;
      }
    }),
    phase: Yup.mixed().test('phase', 'Company is required', (value) => {
      //  formRef.current?.values?.type?.value !== "Corporate" &&
      // formRef.current?.values?.type?.value !== "Site" &&
      if (!value?.companyName) {
        return false;
      } else {
        return true;
      }
    }),
    // type: Yup.mixed().test("type", "Type is required", (value) => {
    //   if (!value?.value) {
    //     return false;
    //   } else {
    //     return true;
    //   }
    // }),
    corporateName:
      formRef.current?.values?.type?.value !== 'RevOne Company' &&
      Yup.mixed().test('corporateName', 'Corporate Name is required', (value) => {
        if (!value?.corporateName) {
          return false;
        } else {
          return true;
        }
      }),
    siteName:
      formRef.current?.values?.type?.value !== 'RevOne Company' &&
      formRef.current?.values?.type?.value !== 'Corporate' &&
      Yup.mixed().test('siteName', 'Site Name is required', (value) => {
        if (!value?.siteName) {
          return false;
        } else {
          return true;
        }
      }),
  });

  const getEventTriggerData = (data) => {
    return data?.length > 0 ? data?.map((i) => i?.code)?.toString() : [];
  };
  useEffect(() => {
    setUnique(false);
  }, []);
  const handleSubmit = (values) => {
    const data = {
      ...values,
      clientCode: values?.clientCode?.clientNumber ? values?.clientCode?.clientNumber : '',
      correspondingClients: values?.correspondingClients?.key ?
        values?.correspondingClients?.key :
        '',
      corporateName: values?.corporateName?.corporateName ?
        values?.corporateName?.corporateName :
        '',
      siteName: values?.siteName?.siteName ? values?.siteName?.siteName : '',
      phase: values?.phase?.companyId ? values?.phase?.companyId : null,
      eventTactic: selectedEventTrigger,
      type: values?.type?.value ? values?.type?.value : '',
    };
    const copyData = [...AttachedTriggersData];
    if (!isEdit) {
      copyData.push({...data});
      const cleanArray = copyData.reduce((unique, o) => {
        if (
          !unique.some((obj) => {
            if (obj?.type === 'RevOne Company') {
              return (
                obj?.phase?.toString() === o?.phase?.toString() &&
                obj.type === o.type &&
                obj?.eventTactic[0]?.code === o.eventTactic[0]?.code
              );
            } else if (obj?.type === 'Corporate') {
              return (
                obj?.corporateName === o?.corporateName &&
                obj.type === o.type &&
                obj?.phase?.toString() === o?.phase?.toString() &&
                obj?.eventTactic[0]?.code === o.eventTactic[0]?.code
              );
            } else if (obj?.type === 'Site') {
              return (
                obj?.corporateName === o?.corporateName &&
                obj.type === o.type &&
                obj.siteName === o.siteName &&
                obj?.phase?.toString() === o?.phase?.toString() &&
                obj?.eventTactic[0]?.code === o.eventTactic[0]?.code
              );
            } else if (obj?.type === 'Department') {
              return (
                obj?.corporateName === o?.corporateName &&
                obj.type === o.type &&
                obj.siteName === o.siteName &&
                obj.clientCode === o.clientCode &&
                obj?.phase?.toString() === o?.phase?.toString() &&
                obj?.eventTactic[0]?.code === o.eventTactic[0]?.code
              );
            }
          })
        ) {
          unique.push(o);
        }
        return unique;
      }, []);
      if (copyData?.length > cleanArray?.length) {
        setUnique(true);
      } else {
        setAttachedTriggersData(cleanArray);
        setOpenPopup(false);
        setUnique(false);
      }
    } else {
      const updatedData = copyData.map((each, i) => {
        const {tableData} = clientRowData;
        if (each.tableData?.id === tableData?.id) {
          return {
            ...each,
            clientCode: data?.clientCode || '',
            correspondingClients: data?.correspondingClients,
            eventTactic: data?.eventTactic ? data?.eventTactic : [],
            type: data?.type ? data?.type : '',
            corporateName: data?.corporateName ? data?.corporateName : '',
            siteName: data?.siteName ? data?.siteName : '',
            phase: data?.phase ? data?.phase : null,
          };
        } else {
          return {
            ...each,
          };
        }
      });
      const cleanArrays = updatedData.reduce((unique, o) => {
        if (
          !unique.some((obj) => {
            if (obj?.type === 'RevOne Company') {
              return (
                obj.type === o.type &&
                obj?.phase === o?.phase &&
                obj?.eventTactic[0]?.code === o.eventTactic[0]?.code
              );
            } else if (obj?.type === 'Corporate') {
              return (
                obj?.corporateName === o?.corporateName &&
                obj?.phase === o?.phase &&
                obj.type === o.type &&
                obj?.eventTactic[0]?.code === o.eventTactic[0]?.code
              );
            } else if (obj?.type === 'Site') {
              return (
                obj?.corporateName === o?.corporateName &&
                obj.type === o.type &&
                obj?.eventTactic[0]?.code === o.eventTactic[0]?.code &&
                obj.siteName === o.siteName &&
                obj?.phase === o?.phase
              );
            } else if (obj?.type === 'Department') {
              return (
                obj?.corporateName === o?.corporateName &&
                obj.type === o.type &&
                obj.siteName === o.siteName &&
                obj.clientCode === o.clientCode &&
                obj?.phase === o?.phase &&
                obj?.eventTactic[0]?.code === o.eventTactic[0]?.code
              );
            }
          })
        ) {
          unique.push(o);
        }
        return unique;
      }, []);
      if (copyData?.length > cleanArrays?.length) {
        setUnique(true);
      } else {
        setAttachedTriggersData(updatedData);
        setIsEdit(false);
        setUnique(false);
      }
    }
    handleDirty(true);
  };

  useEffect(() => {
    if (isEdit && ['Site', 'Department']?.includes(clientRowData?.type)) {
      const corporateId = getObjects(clientRowData?.corporateName, corporateNameData)?.corporateId;

      if (corporateId) {
        dispatch(fetchSiteNameData(corporateId));
      }
      // setInitialValues((prev) => ({
      //   ...prev,
      //   ...initialVal,
      //   siteName: getObjects(clientRowData?.siteName, siteNameData),
      // }));
    } else if (isEdit && ['Corporate']?.includes(clientRowData?.type)) {
      setInitialValues({
        ...initialVal,
        corporateName:
          isEdit && clientRowData && clientRowData?.corporateName ?
            getObjects(clientRowData?.corporateName, corporateNameData) :
            '',
      });
    }
  }, [clientRowData, corporateNameData]);
  useEffect(() => {
    if (isEdit && clientRowData?.corporateName) {
      setInitialValues({
        ...initialVal,
        corporateName: getObjects(clientRowData?.corporateName, corporateNameData) || '',
      });
    }
  }, [corporateNameData]);
  useEffect(() => {
    if (isEdit && ['Department']?.includes(clientRowData?.type)) {
      const siteId = getObjects(clientRowData?.siteName, siteNameData)?.siteId;
      if (siteId) {
        dispatch(fetchClientNumberData(siteId));
      }
    }
  }, [clientRowData, siteNameData]);
  useEffect(() => {
    if (isEdit && ['Site', 'Department']?.includes(clientRowData?.type)) {
      setInitialValues((prev) => ({
        ...prev,
        ...initialVal,
        clientCode: getObjects(clientRowData?.clientCode, clientNumberData),
        siteName: getObjects(clientRowData?.siteName, siteNameData),
        corporateName: formRef?.current?.values?.corporateName || '',
      }));
    }
  }, [clientRowData, clientNumberData, siteNameData]);
  useEffect(() => {
    dispatch(fetchCompanyDropDownData());
  }, []);
  useEffect(() => {
    if (isEdit && !['RevOne Company']?.includes(clientRowData?.type)) {
      const companyId = getObjects(clientRowData?.phase, companyAPIdata)?.companyId;
      if (companyId) {
        dispatch(fetchCorporateNameData(companyId));
      }
    }
  }, [clientRowData, companyAPIdata]);
  return (
    <>
      <div className={classes.addRule}>
        <div className={classes.dialoguecardStyles}>
          <Formik
            onSubmit={(values) => handleSubmit(values)}
            initialValues={initialValues}
            validationSchema={schema}
            enableReinitialize
            validateOnChange
            innerRef={formRef}
          >
            {(props) => {
              const {
                values,

                handleSubmit,
                setFieldValue,
                handleReset,
                handleChange,
                touched,
                errors,
                resetForm,
                handleBlur,
              } = props;
              return (
                <>
                  {searchEventTactics ? (
                    <>
                      <div className="button-table-spacing-mb justify-content-start new-standard-textfields">
                        <Button
                          variant="text"
                          className={`search-btn ${classes.buttonRoot}`}
                          onClick={() => {
                            setSearchEventTactics(false);
                          }}
                        >
                          <ArrowBack className="mr-2" />
                          Go Back
                        </Button>
                      </div>
                      <SearchEventTactics
                        handleClose={handleEventTacticSearch}
                        setSelectedEventTrigger={setSelectedEventTrigger}
                        selectedEventTrigger={selectedEventTrigger}
                        isEventTriggerGroup={true}
                        eventType={eventType}
                        cardSpace={cardSpace}
                        searchEventTactics={searchEventTactics}
                        setSearchEventTactics={setSearchEventTactics}
                      />
                    </>
                  ) : (
                    <>
                      <div>
                        {unique && (
                          <Alert className="mb-2" severity="error">
                            {values?.type?.value === 'RevOne Company'
                              ? 'Company and Trigger Combination already exists'
                              : values?.type?.value === 'Corporate'
                                ? 'Corporate and Trigger Combination already exists'
                                : values?.type?.value === 'Site'
                                  ? 'Site and Trigger Combination already exists'
                                  : values?.type?.value === 'Department'
                                    ? 'Department and Trigger Combination already exists'
                                    : ''}
                          </Alert>
                        )}
                        <BreadCrums
                          name={' Event Trigger Name'}
                          code={eventCode}
                          description={' Event Trigger Description'}
                          descriptionValue={eventDescription}
                        />
                        <form
                          autoComplete="off"
                          noValidate
                          onSubmit={handleSubmit}
                          onReset={handleReset}
                        >
                          <div className="mt-2 standard-field-textfields new-standard-textfields">
                            <ErrorBoundaryForComponents>
                              <Grid container spacing={2}>
                                <Grid item xs={4} className="form-group">
                                  <GuiAutoComplete
                                    classes={{
                                      option: classes.option,
                                    }}
                                    name="type"
                                    id="type"
                                    size="small"
                                    value={values.type}
                                    options={groupTypeDropdownValues}
                                    disabled={isEdit}
                                    getOptionDisabled={(option) => option?.valueCode === 'none'}
                                    getOptionLabel={(option) => {
                                      return option && option.value
                                        ? option?.valueCode === null
                                          ? option?.value
                                          : option?.value
                                        : '';
                                    }}
                                    required
                                    onChange={(e, value) => {
                                      setFieldValue('type', value);
                                      if (!isEdit) {
                                        setFieldValue('clientCode', '');
                                        setFieldValue('correspondingClients', '');
                                        setFieldValue('phase', null);
                                        setFieldValue('corporateName', '');
                                        setFieldValue('siteName', '');
                                        setSelectedEventTrigger([]);
                                      }
                                    }}
                                    renderInput={(params) => (
                                      <div className="select-field">
                                        <GuiTextField
                                          {...params}
                                          error={Boolean(touched?.type && errors?.type)}
                                          variant="outlined"
                                          margin="dense"
                                          // InputLabelProps={{
                                          //   shrink: true,
                                          // }}
                                          required
                                          label="Type"
                                          placeholder="Select Type"
                                          className={`${classes.labelName}`}
                                        />
                                      </div>
                                    )}
                                  />
                                  <FormHelperText>
                                    {touched?.type && errors?.type && errors?.type}
                                  </FormHelperText>
                                </Grid>
                                {/* <Grid container item xs={6} className="form-group account-guarantor"> */}
                                {/* {(values?.type?.value === "Department" ||
                                  values?.type?.value === "Revone Company") && ( */}
                                {values?.type?.value && (
                                  <>
                                    <Grid item xs={4} className="form-group">
                                      <GuiAutoComplete
                                        classes={{
                                          option: classes.option,
                                        }}
                                        name={`phase`}
                                        id={`phase`}
                                        size="small"
                                        value={values?.phase}
                                        // options={getOptions(PHASE, dropDownData)}
                                        options={companyAPIdata}
                                        disabled={
                                          isEdit &&
                                          !['RevOne Company']?.includes(clientRowData?.type)
                                        }
                                        getOptionLabel={(option) => {
                                          // return option?.value ? option?.value : "";
                                          return option.companyName ? option.companyName : '';
                                        }}
                                        required
                                        onChange={(e, value) => {
                                          dispatch(resetSiteName());
                                          dispatch(resetClientNumber());
                                          dispatch(resetCorporateName());
                                          setFieldValue('clientCode', '');
                                          setFieldValue('siteName', '');
                                          setFieldValue('corporateName', '');
                                          setFieldValue(`phase`, value);
                                          if (
                                            value?.companyId &&
                                            values?.type?.value !== 'RevOne Company'
                                          ) {
                                            dispatch(fetchCorporateNameData(value?.companyId));
                                          }
                                        }}
                                        renderInput={(params) => (
                                          <div className="select-field">
                                            <GuiTextField
                                              {...params}
                                              variant="outlined"
                                              margin="dense"
                                              // InputLabelProps={{
                                              //   shrink: true,
                                              // }}
                                              required
                                              label="Company"
                                              error={Boolean(touched?.phase && errors?.phase)}
                                              placeholder="Select Company"
                                              className={`${classes.labelName}`}
                                            />
                                          </div>
                                        )}
                                      />

                                      <FormHelperText style={{ color: 'red' }}>
                                        {touched.phase && errors.phase}
                                      </FormHelperText>
                                    </Grid>
                                  </>
                                )}
                                {/* </Grid> */}
                                {(values?.type?.value === 'Corporate' ||
                                  values?.type?.value === 'Site' ||
                                  values?.type?.value === 'Department') && (
                                  <>
                                    <Grid item xs={4} className="form-group">
                                      <GuiAutoComplete
                                        classes={{
                                          option: classes.option,
                                        }}
                                        name="corporateName"
                                        id="corporateName"
                                        size="small"
                                        value={values?.corporateName}
                                        options={corporateNameData || []}
                                        getOptionLabel={(option) => {
                                          return option.corporateName || '';
                                        }}
                                        freeSolo
                                        onChange={(e, value) => {
                                          dispatch(resetSiteName());
                                          dispatch(resetClientNumber());
                                          setFieldValue('clientCode', '');
                                          setFieldValue('siteName', '');
                                          if (
                                            value?.corporateId &&
                                            ['Site', 'Department']?.includes(values?.type?.value)
                                          ) {
                                            dispatch(fetchSiteNameData(value?.corporateId));
                                          }
                                          setFieldValue('corporateName', value);
                                          dispatch(fetchSiteNameData(value?.corporateId));
                                          setFieldValue('corporateName', value);
                                        }}
                                        renderInput={(params) => (
                                          <div className="select-field close-icon">
                                            <GuiTextField
                                              {...params}
                                              variant="outlined"
                                              className={`${classes.labelName}`}
                                              margin="dense"
                                              required
                                              error={Boolean(
                                                touched.corporateName && errors.corporateName,
                                              )}
                                              label="Corporate Name"
                                              placeholder="Select Corporate Name"
                                            />
                                          </div>
                                        )}
                                      />
                                      <FormHelperText style={{ color: 'red' }}>
                                        {touched.corporateName &&
                                          errors?.corporateName &&
                                          errors.corporateName}
                                      </FormHelperText>
                                    </Grid>
                                  </>
                                )}
                                {(values?.type?.value === 'Site' ||
                                  values?.type?.value === 'Department') && (
                                  <>
                                    <Grid item xs={4} className="form-group">
                                      <GuiAutoComplete
                                        classes={{
                                          option: classes.option,
                                        }}
                                        name="siteName"
                                        id="siteName"
                                        size="small"
                                        value={values.siteName}
                                        freeSolo
                                        options={siteNameData || []}
                                        getOptionLabel={(option) => {
                                          return option.siteName || '';
                                        }}
                                        onChange={(e, value) => {
                                          dispatch(resetClientNumber());
                                          setFieldValue('clientCode', '');
                                          if (
                                            value?.siteId &&
                                            ['Department']?.includes(values?.type?.value)
                                          ) {
                                            dispatch(fetchClientNumberData(value?.siteId));
                                          }
                                          setFieldValue('siteName', value);
                                        }}
                                        renderInput={(params) => (
                                          <div className="select-field">
                                            <GuiTextField
                                              {...params}
                                              className={`${classes.labelName}`}
                                              variant="outlined"
                                              margin="dense"
                                              required
                                              error={Boolean(touched.siteName && errors.siteName)}
                                              label="Site Name"
                                              placeholder="Select Site Name"
                                            />
                                          </div>
                                        )}
                                      />
                                      <FormHelperText style={{ color: 'red' }}>
                                        {touched.siteName && errors?.siteName && errors.siteName}
                                      </FormHelperText>
                                    </Grid>
                                  </>
                                )}

                                {values?.type?.value === 'Department' && (
                                  <>
                                    <Grid item xs={4} className="form-group">
                                      <GuiAutoComplete
                                        classes={{
                                          option: classes.option,
                                        }}
                                        name="clientCode"
                                        id="clientCode"
                                        size="small"
                                        value={values.clientCode}
                                        options={clientNumberData || []}
                                        handleBlur={handleBlur}
                                        getOptionDisabled={(option) => option.clientNumber === ''}
                                        getOptionLabel={(option) => {
                                          return option?.clientNumber ? option?.clientNumber : '';
                                        }}
                                        required
                                        onChange={(e, value) => {
                                          setFieldValue('clientCode', value);
                                        }}
                                        renderInput={(params) => (
                                          <div className="select-field">
                                            <GuiTextField
                                              {...params}
                                              error={Boolean(
                                                touched.clientCode && errors.clientCode,
                                              )}
                                              variant="outlined"
                                              margin="dense"
                                              // InputLabelProps={{
                                              //   shrink: true,
                                              // }}
                                              required
                                              label="Department"
                                              placeholder="Select Department"
                                              className={`${classes.labelName}`}
                                            />
                                          </div>
                                        )}
                                      />
                                      <FormHelperText>
                                        {touched.clientCode &&
                                          errors.clientCode &&
                                          errors.clientCode}
                                      </FormHelperText>
                                    </Grid>
                                  </>
                                )}
                                <Grid item xs={4} className="form-group">
                                  <GuiAutoComplete
                                    classes={{
                                      option: classes.option,
                                    }}
                                    name="correspondingClients"
                                    id="correspondingClients"
                                    size="small"
                                    value={values.correspondingClients}
                                    options={correspondingClientsTypes}
                                    getOptionLabel={(option) => {
                                      return option && option.key ? option.value : '';
                                    }}
                                    // required
                                    onChange={(e, value) => {
                                      setFieldValue('correspondingClients', value);
                                    }}
                                    renderInput={(params) => (
                                      <div className="select-field">
                                        <GuiTextField
                                          {...params}
                                          error={Boolean(
                                            touched.correspondingClients &&
                                              errors.correspondingClients,
                                          )}
                                          variant="outlined"
                                          margin="dense"
                                          // InputLabelProps={{
                                          //   shrink: true,
                                          // }}
                                          // required
                                          label="Continue After Processing"
                                          placeholder="Select Continue After Processing"
                                          className={`${classes.labelName}`}
                                        />
                                      </div>
                                    )}
                                  />
                                  <FormHelperText>
                                    {touched.correspondingClients &&
                                      errors.correspondingClients &&
                                      errors.correspondingClients}
                                  </FormHelperText>
                                </Grid>
                                <Grid item xs={4} className="form-group wait-date-disable-field">
                                  <TextField
                                    margin="dense"
                                    className={`${classes.labelName}`}
                                    variant="outlined"
                                    placeholder={`Enter Triggers`}
                                    label="Triggers"
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                    name="eventTactic"
                                    value={getEventTriggerData(selectedEventTrigger)}
                                    onChange={(e) => {
                                      handleChange(e);
                                      setFieldValue('eventTactic', e.target.value);
                                    }}
                                    fullWidth
                                    handleBlur={handleBlur}
                                    required
                                    touched={touched?.eventTactic}
                                    error={
                                      selectedEventTrigger?.length > 0
                                        ? null
                                        : Boolean(touched?.eventTactic && errors?.eventTactic)
                                    }
                                    disabled
                                    InputProps={{
                                      endAdornment: (
                                        <InputAdornment position="end">
                                          <Tooltip title={'Search'}>
                                            <Search
                                              className={` ${classes.iconSearch}`}
                                              onClick={() => {
                                                setCardSpace(true);
                                                setSearchEventTactics(true);
                                              }}
                                              size="sm"
                                            />
                                          </Tooltip>
                                          <Tooltip title={'Clear'}>
                                            <Clear
                                              className={` ${classes.iconSearch}`}
                                              onClick={(e) => setSelectedEventTrigger([])}
                                            />
                                          </Tooltip>
                                        </InputAdornment>
                                      ),
                                    }}
                                  />
                                  <FormHelperText style={{ color: 'red' }}>
                                    {selectedEventTrigger?.length > 0
                                      ? null
                                      : touched?.eventTactic && errors?.eventTactic}
                                  </FormHelperText>
                                </Grid>
                              </Grid>
                            </ErrorBoundaryForComponents>
                          </div>
                          <div className="new-standard-textfields d-flex justify-content-center">
                            <Button
                              variant="outlined"
                              onClick={() => {
                                resetForm(initialValues);
                                setUnique(false);
                                setSelectedEventTrigger(
                                  isEdit && clientRowData ? clientRowData?.eventTactic : [],
                                );
                              }}
                              disbled={!disable?.edit}
                              className={`mx-1 reset-btn ${classes.buttonRoot}`}
                            >
                              Reset
                            </Button>
                            <Button
                              variant="outlined"
                              type="submit"
                              className={`search-btn mx-1 ${classes.buttonRoot}`}
                              disabled={!disable?.edit}
                            >
                              Save
                            </Button>
                          </div>
                        </form>
                      </div>
                    </>
                  )}
                </>
              );
            }}
          </Formik>
        </div>
      </div>
      {isLoading && <PageLoader />}
    </>
  );
};

export default AddClientForm;
